import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ViewAndUpload from "@components/ViewAndUpload/ViewAndUpload";
import {
  GenrealInfo,
  Title,
  FlexRow,
  FlexRowLi,
  GridRow,
  SubTitle,
  DescriptionData,
} from "./GeneralData.styled";

const GeneralData = (props) => {
  const { t, data } = props;

  return (
    <GenrealInfo>
      <FlexRow column="1fr">
        <Title>{t("GENERAL_INFORMATION")}</Title>
      </FlexRow>
      {data.acceptanceRequirements && (
        <>
          <GridRow column="1fr">
            <SubTitle>{t("ACCEPTANCE_REQUIREMENTS")}</SubTitle>
          </GridRow>
          <DescriptionData>
            <div
              dangerouslySetInnerHTML={{
                __html: data.acceptanceRequirements,
              }}
            ></div>
          </DescriptionData>
        </>
      )}
      {data.internalComment && (
        <>
          <GridRow column="1fr">
            <SubTitle>{t("ADDITIONAL_INFORMATION")}</SubTitle>
          </GridRow>
          <DescriptionData>
            <div
              dangerouslySetInnerHTML={{
                __html: data.internalComment,
              }}
            ></div>
          </DescriptionData>
        </>
      )}
      <GridRow column="1fr 1fr 1fr">
        <Title>{t("VALORISATION")}</Title>
        {data.product?.category.id === 2 && (
          <Title>{t("MATERIAL_INFORMATION")}</Title>
        )}
        {(data.dailyMaxQuantity !== null ||
          data.dailyMaxQuantity !== "" ||
          data.annualMaxQuantity !== null ||
          data.annualMaxQuantity !== "" ||
          data.residualCapacity !== null ||
          data.residualCapacity !== "" ||
          data.minimumBilling !== null ||
          data.minimumBilling !== "") && <Title>{t("OTHER_DETAILS")}</Title>}
      </GridRow>
      <GridRow column="1fr 1fr 1fr">
        <div>
          <FlexRow>
            <SubTitle>{t("VALORISATION_RATE")} :</SubTitle>
            <SubTitle color="#767676" paddingLeft="10px">
              {data.valorisationRate !== null
                ? data.valorisationRate + "%"
                : ""}
            </SubTitle>
          </FlexRow>
          <FlexRow>
            <SubTitle>{t("VALORISATION_TREATMENT")} :</SubTitle>
            <SubTitle color="#767676" paddingLeft="10px">
              {data.valorisationTreatment}
            </SubTitle>
          </FlexRow>
        </div>
        {data.product?.category.id === 2 && (
          <div>
            <FlexRow>
              <SubTitle>{t("MATERIAL_USAGE")} :</SubTitle>
            </FlexRow>
            <ul>
              {data.materialUsages !== null &&
                data.materialUsages.map((usages, index) => {
                  return (
                    <li key={index}>
                      <FlexRowLi>
                        <SubTitle color="#767676">{usages.name}</SubTitle>
                      </FlexRowLi>
                    </li>
                  );
                })}
            </ul>
          </div>
        )}
        <div>
          {data.dailyMaxQuantity !== null && data.dailyMaxQuantity !== "" && (
            <FlexRow>
              <SubTitle>{t("DAILY_MAX_QUANTITY")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.dailyMaxQuantity}
              </SubTitle>
            </FlexRow>
          )}
          {data.annualMaxQuantity !== null && data.annualMaxQuantity !== "" && (
            <FlexRow>
              <SubTitle>{t("ANNUAL_MAX_QUANTITY")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.annualMaxQuantity}
              </SubTitle>
            </FlexRow>
          )}
          {data.residualCapacity !== null && data.residualCapacity !== "" && (
            <FlexRow>
              <SubTitle>{t("RESIDUAL_QUANTITY")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.residualCapacity}
              </SubTitle>
            </FlexRow>
          )}
          {data.minimumBilling !== null && data.minimumBilling !== "" && (
            <FlexRow>
              <SubTitle>{t("MIN_BILLING")} :</SubTitle>
              <SubTitle color="#767676" paddingLeft="10px">
                {data.minimumBilling}
              </SubTitle>
            </FlexRow>
          )}
        </div>
      </GridRow>
      <ViewAndUpload
        documents={data.documents}
        type="19"
        id={data.id}
        entity="centerProductId"
      />
    </GenrealInfo>
  );
};

GeneralData.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(GeneralData);
